import React from "react";
import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import { Flex, Text } from "../../../styles/utility-components";

type Props = {
  isOpen: boolean;
  criteriaTitle: string;
  closeModal: () => void;
  deleteQuestion: () => void;
};

export function DeleteCriteriaModal({ isOpen, closeModal, criteriaTitle, deleteQuestion }: Props) {
  return (
    <Modal isOpen={isOpen} modalClose={closeModal} showCloseButton={false}>
      <Content gap={16} flexDirection="column">
        <Text h3>About to delete custom criteria</Text>
        <Flex gap={8} flexDirection="column">
          <Text>
            Are you sure you want to delete this custom criteria? <Text bold>{criteriaTitle}</Text>
          </Text>
          <Text>
            This criteria will not be shown on any new reports or on existing reports if you
            recreate them.
          </Text>
          <Text>This action cannot be undone.</Text>
        </Flex>
        <Flex gap={8} justifyContent="flex-end">
          <Button onClick={closeModal} buttonType="secondary">
            Keep criteria
          </Button>
          <Button
            buttonStyle="destructive"
            onClick={() => {
              deleteQuestion();
              closeModal();
            }}
          >
            Delete criteria
          </Button>
        </Flex>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  width: 440,
  gap: 16,
  flexDirection: "column",
  padding: 16,
});
